import { render, staticRenderFns } from "./ui-switch.vue?vue&type=template&id=c9c87e5c&scoped=true&"
import script from "./ui-switch.vue?vue&type=script&lang=js&"
export * from "./ui-switch.vue?vue&type=script&lang=js&"
import style0 from "./ui-switch.vue?vue&type=style&index=0&id=c9c87e5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c87e5c",
  null
  
)

export default component.exports